export { useWidgetDialog } from './useWidgetDialog';
export type { UseWidgetDialogOptions } from './types';
